import { useGetNearestDropOffLocationQuery } from './graphql.generated';

export const useNearestLocation = (
	lat: number | null | undefined,
	lng: number | null | undefined
) => {
	const { data, loading } = useGetNearestDropOffLocationQuery({
		variables: { lat: lat ?? 0, lng: lng ?? 0 },
		skip: !lat || !lng,
	});

	return {
		nearestLocation: data?.nearestDropOffLocation,
		loading,
	};
};
